import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_f5c38e9e from 'nuxt_plugin_sentryserver_f5c38e9e' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_1f64c729 from 'nuxt_plugin_sentryclient_1f64c729' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_bootstrapvue_8b7551c8 from 'nuxt_plugin_bootstrapvue_8b7551c8' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_vuematerial_150503fd from 'nuxt_plugin_vuematerial_150503fd' // Source: ./vue-material.js (mode: 'all')
import nuxt_plugin_nuxtsocketio_bb16e7d6 from 'nuxt_plugin_nuxtsocketio_bb16e7d6' // Source: ./nuxt-socket-io.js (mode: 'all')
import nuxt_plugin_workbox_49d163c9 from 'nuxt_plugin_workbox_49d163c9' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_ea5a5c48 from 'nuxt_plugin_metaplugin_ea5a5c48' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_e10b1160 from 'nuxt_plugin_iconplugin_e10b1160' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_22d6b5ed from 'nuxt_plugin_axios_22d6b5ed' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vuemodal_ec9b54a2 from 'nuxt_plugin_vuemodal_ec9b54a2' // Source: ../plugins/vue-modal (mode: 'all')
import nuxt_plugin_materialsettings_4fd99953 from 'nuxt_plugin_materialsettings_4fd99953' // Source: ../plugins/material-settings.js (mode: 'all')
import nuxt_plugin_axiossetup_9bfbfa72 from 'nuxt_plugin_axiossetup_9bfbfa72' // Source: ../plugins/axios-setup.js (mode: 'all')
import nuxt_plugin_veevalidate_1a0c1998 from 'nuxt_plugin_veevalidate_1a0c1998' // Source: ../plugins/vee-validate.js (mode: 'all')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_helperplugins_15448120 from 'nuxt_plugin_helperplugins_15448120' // Source: ../plugins/helper-plugins.js (mode: 'all')
import nuxt_plugin_vuegoodtable_6479f65b from 'nuxt_plugin_vuegoodtable_6479f65b' // Source: ../plugins/vue-good-table (mode: 'client')
import nuxt_plugin_vuejstogglebutton_5e97b824 from 'nuxt_plugin_vuejstogglebutton_5e97b824' // Source: ../plugins/vue-js-toggle-button (mode: 'client')
import nuxt_plugin_vuetoastnotification_6590096e from 'nuxt_plugin_vuetoastnotification_6590096e' // Source: ../plugins/vue-toast-notification (mode: 'client')
import nuxt_plugin_bootstrapvue_928a4c1e from 'nuxt_plugin_bootstrapvue_928a4c1e' // Source: ../plugins/bootstrap-vue (mode: 'client')
import nuxt_plugin_vueclipboardcopy_74d45269 from 'nuxt_plugin_vueclipboardcopy_74d45269' // Source: ../plugins/vue-clipboard-copy (mode: 'client')
import nuxt_plugin_vuegooglecharts_131e05ac from 'nuxt_plugin_vuegooglecharts_131e05ac' // Source: ../plugins/vue-google-charts (mode: 'client')
import nuxt_plugin_vuegoogleautocomplete_8bb39802 from 'nuxt_plugin_vuegoogleautocomplete_8bb39802' // Source: ../plugins/vue-google-autocomplete (mode: 'client')
import nuxt_plugin_vuenavtabs_3442d676 from 'nuxt_plugin_vuenavtabs_3442d676' // Source: ../plugins/vue-nav-tabs (mode: 'client')
import nuxt_plugin_vuetelinput_44ffc74a from 'nuxt_plugin_vuetelinput_44ffc74a' // Source: ../plugins/vue-tel-input (mode: 'client')
import nuxt_plugin_vuecountryregionselect_0404277e from 'nuxt_plugin_vuecountryregionselect_0404277e' // Source: ../plugins/vue-country-region-select (mode: 'client')
import nuxt_plugin_vuetooltip_f49054f4 from 'nuxt_plugin_vuetooltip_f49054f4' // Source: ../plugins/vue-tooltip (mode: 'client')
import nuxt_plugin_vueawesomeswiper_4af85e3f from 'nuxt_plugin_vueawesomeswiper_4af85e3f' // Source: ../plugins/vue-awesome-swiper (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"layup-merchant","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:400,500,700,400italic|Material+Icons"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_f5c38e9e === 'function') {
    await nuxt_plugin_sentryserver_f5c38e9e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_1f64c729 === 'function') {
    await nuxt_plugin_sentryclient_1f64c729(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_8b7551c8 === 'function') {
    await nuxt_plugin_bootstrapvue_8b7551c8(app.context, inject)
  }

  if (typeof nuxt_plugin_vuematerial_150503fd === 'function') {
    await nuxt_plugin_vuematerial_150503fd(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsocketio_bb16e7d6 === 'function') {
    await nuxt_plugin_nuxtsocketio_bb16e7d6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_49d163c9 === 'function') {
    await nuxt_plugin_workbox_49d163c9(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_ea5a5c48 === 'function') {
    await nuxt_plugin_metaplugin_ea5a5c48(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_e10b1160 === 'function') {
    await nuxt_plugin_iconplugin_e10b1160(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_22d6b5ed === 'function') {
    await nuxt_plugin_axios_22d6b5ed(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemodal_ec9b54a2 === 'function') {
    await nuxt_plugin_vuemodal_ec9b54a2(app.context, inject)
  }

  if (typeof nuxt_plugin_materialsettings_4fd99953 === 'function') {
    await nuxt_plugin_materialsettings_4fd99953(app.context, inject)
  }

  if (typeof nuxt_plugin_axiossetup_9bfbfa72 === 'function') {
    await nuxt_plugin_axiossetup_9bfbfa72(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_1a0c1998 === 'function') {
    await nuxt_plugin_veevalidate_1a0c1998(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  if (typeof nuxt_plugin_helperplugins_15448120 === 'function') {
    await nuxt_plugin_helperplugins_15448120(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegoodtable_6479f65b === 'function') {
    await nuxt_plugin_vuegoodtable_6479f65b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejstogglebutton_5e97b824 === 'function') {
    await nuxt_plugin_vuejstogglebutton_5e97b824(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetoastnotification_6590096e === 'function') {
    await nuxt_plugin_vuetoastnotification_6590096e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bootstrapvue_928a4c1e === 'function') {
    await nuxt_plugin_bootstrapvue_928a4c1e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueclipboardcopy_74d45269 === 'function') {
    await nuxt_plugin_vueclipboardcopy_74d45269(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegooglecharts_131e05ac === 'function') {
    await nuxt_plugin_vuegooglecharts_131e05ac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegoogleautocomplete_8bb39802 === 'function') {
    await nuxt_plugin_vuegoogleautocomplete_8bb39802(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuenavtabs_3442d676 === 'function') {
    await nuxt_plugin_vuenavtabs_3442d676(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetelinput_44ffc74a === 'function') {
    await nuxt_plugin_vuetelinput_44ffc74a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecountryregionselect_0404277e === 'function') {
    await nuxt_plugin_vuecountryregionselect_0404277e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetooltip_f49054f4 === 'function') {
    await nuxt_plugin_vuetooltip_f49054f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_4af85e3f === 'function') {
    await nuxt_plugin_vueawesomeswiper_4af85e3f(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
